"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const XIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.332 6.928L14.544 1h-1.235L8.783 6.147 5.17 1H1l5.466 7.784L1 15h1.235l4.78-5.436L10.83 15H15L9.332 6.928zM7.64 8.852l-.554-.775L2.68 1.91h1.897l3.556 4.977.554.775 4.622 6.47h-1.897L7.64 8.852z"
  })))
});
XIcon.displayName = 'XIcon';
var _default = exports.default = XIcon;